function isAnswered(v) {
    if (v === undefined || v === null || v === "")
        return false;
    if (Array.isArray(v))
        return v.length > 0;
    return true;
}
/** Evaluates a showIf condition (6.4) against the current answers. Unanswered references are false. */
export function evaluateCondition(c, answers) {
    if ("all" in c)
        return c.all.every((x) => evaluateCondition(x, answers));
    if ("any" in c)
        return c.any.some((x) => evaluateCondition(x, answers));
    const v = answers[c.node];
    switch (c.op) {
        case "answered":
            return isAnswered(v);
        case "equals":
            return isAnswered(v) && !Array.isArray(v) && typeof v !== "object" && v === c.value;
        case "notEquals":
            return isAnswered(v) && !Array.isArray(v) && typeof v !== "object" && v !== c.value;
        case "includes":
            return Array.isArray(v) ? v.includes(c.value) : typeof v === "string" && v === c.value;
    }
}
/** Node ids referenced by a condition. */
export function conditionRefs(c) {
    if ("all" in c)
        return c.all.flatMap(conditionRefs);
    if ("any" in c)
        return c.any.flatMap(conditionRefs);
    return [c.node];
}
//# sourceMappingURL=conditions.js.map